import * as React from "react";

export default class CheckoutContent extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <div className={`checkout-contents__item ${classes && classes}`}>
      {children}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/CheckoutContent.js